import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { SelectFieldComponent } from '../../../../components/form/select-field/select-field.component';
import { SelectOption } from '../../../../components/form/select-field/select-field.config';
import { MeetingMinuteRowsBase } from '../meeting-minute-rows/meeting-minute-rows.base';

import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

@Component({
  selector: 'meeting-minute-actions',
  imports: [ReactiveFormsModule, InputFieldComponent, SelectFieldComponent],
  templateUrl: './meeting-minute-actions.component.html',
  styleUrl: '../meeting-minute-rows/meeting-minute-rows.scss'
})
export class MeetingMinuteActionsComponent extends MeetingMinuteRowsBase {

  @Input() userOptions: SelectOption[] = [];

  protected readonly idControlName = 'meetingMinuteActionId';
  protected readonly rowLabel = 'action';

  constructor(confirmationDialogService: ConfirmationDialogService) {
    super(confirmationDialogService);
  }
}
